import { IPublicClientApplication, AccountInfo } from '@azure/msal-browser';
import { createAuthenticatedFetch } from './apiClient';

let authenticatedFetch: ((url: string, options?: RequestInit) => Promise<Response>) | null = null;

export const initializeAuthenticatedFetch = (
    msalInstance: IPublicClientApplication,
    account: AccountInfo
) => {
    authenticatedFetch = createAuthenticatedFetch(msalInstance, account);
};

export const getAuthenticatedFetch = (): ((url: string, options?: RequestInit) => Promise<Response>) => {
    if (!authenticatedFetch) {
        throw new Error('Authenticated fetch not initialized. Ensure initializeAuthenticatedFetch is called in App.tsx');
    }
    return authenticatedFetch;
};
